/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Paper, Typography, Box, IconButton, Tooltip } from '@mui/material';
import { ISecretDetailsProps } from '../../models/Machines/ClientContracts';
import { useStyles } from './styles';
import { getExpiryMessage, convertTimeStamp } from '../../utility/dateUtility';
import DeleteBtn from '../../shared/DeleteBtn/DeleteBtn';
import { permissions } from '../../shared/CheckPermissions/constants';
import { deleteClientSecret } from '../../services/client';
import {
  DELETE_CLIENT_SECRET_TITLE,
  DELETE_CLIENT_SECRET_MESSAGE,
  DELETE_CLIENT_SECRET_BUTTON,
  CANCEL_BUTTON,
  DELETE_CLIENT_SECRET_SUCCESS,
  DELETE_CLIENT_SECRET_FAILURE,
  ROTATE_CLIENT_SECRET,
} from './constants';
import { ArrowRefresh } from '@jda/lui-common-icon-library-mui5';

const SecretDetails = ({
  hint,
  expiry,
  machineId,
  keyId,
  refreshOnSave,
  displaySnackbar,
  hideSnackbar,
  hideDeleteButton,
  hideRotateButton,
  rotateClientSecret
}: ISecretDetailsProps) => {
  const { classes } = useStyles();
  return (
    <Paper className={classes.addSecretPaper} variant="outlined">
      <Box className={classes.addSecretBox} data-testid="add-secret-box">
        <Box className={classes.secretHederBox}>
          <Typography  variant="body1" className={classes.paddingStyler} data-testid="secret-hint-text">
            {hint}*************
          </Typography>
          <Box className={classes.paddingStylerDelete}>
            {!hideDeleteButton &&
              <DeleteBtn
                permissions={[permissions.secret.read_write]}
                onDelete={() => deleteClientSecret(machineId, keyId)}
                refreshOnSave={() => {
                  refreshOnSave(machineId);
                }}
                displaySnackbar={displaySnackbar}
                hideSnackbar={hideSnackbar}
                dialog={{
                  title: DELETE_CLIENT_SECRET_MESSAGE,
                  content: DELETE_CLIENT_SECRET_TITLE,
                  primaryButtonText: DELETE_CLIENT_SECRET_BUTTON,
                  secondaryButtonText: CANCEL_BUTTON,
                  recordName: ''
                }}
                messages={{
                  success: DELETE_CLIENT_SECRET_SUCCESS,
                  error: {
                    failure: DELETE_CLIENT_SECRET_FAILURE
                  }
                }}
              />
            }
            {!hideRotateButton &&
              <Tooltip arrow title={ROTATE_CLIENT_SECRET} placement="bottom">
                <IconButton data-testid="rotate-btn" onClick={() => rotateClientSecret(machineId)} >
                  <ArrowRefresh></ArrowRefresh>
                </IconButton>
              </Tooltip>
            }
          </Box>
        </Box>
        <Typography  variant='body2' className={classes.expiry} data-testid="secret-expiry-text">
          {getExpiryMessage(expiry)} {convertTimeStamp(expiry)}
        </Typography>
      </Box>
    </Paper>
  );
};

export default SecretDetails;
